module.exports = __webpack_public_path__ + "img/190318_Bierflasche_Vorderseite_Wassertropfen_02.9ae679c3.png";